export default __webpack_public_path__ + "static/media/surprise-snippet.0ec6b609.png";